import find from 'lodash/find';
import { Dispatch, MouseEvent, SetStateAction } from 'react';

let clickTime = 0;

function onClickRow<T>({
  event,
  setSelectedRowKeys,
  record,
  canSelect = true,
}: {
  event: MouseEvent;
  setSelectedRowKeys: Dispatch<SetStateAction<T[]>>;
  record: T;
  condition?: (callback: (val: boolean) => void) => void;
  canSelect?: boolean;
}) {
  const time = new Date().getTime();
  event.stopPropagation();
  event.preventDefault();
  if ((event?.target as HTMLElement)?.nodeName === 'INPUT') return;

  if (time - clickTime <= 500) return; //? Skip double click
  clickTime = new Date().getTime();

  if (!canSelect) return;

  if (
    new RegExp(
      ['ant-table-selection-column', 'ant-checkbox-wrapper'].join('|')
    ).test((event?.target as HTMLElement)?.className)
  ) {
    return setSelectedRowKeys((selectedRowKeys) => {
      const recordSelected = find(selectedRowKeys, record);

      return recordSelected
        ? selectedRowKeys.filter((row) => row !== record)
        : [...selectedRowKeys, record];
    });
  }

  setSelectedRowKeys((selectedRowKeys) => {
    return find(selectedRowKeys, record) && selectedRowKeys?.length === 1
      ? []
      : [record];
  });
}

export function onDoubleClickRow({
  event,
  callback,
}: {
  event: MouseEvent;
  callback: () => void;
}) {
  event.stopPropagation();
  event.preventDefault();
  const target = event?.target as HTMLElement;

  if (
    ['input', 'button', 'svg'].includes(target?.nodeName.toLocaleLowerCase()) ||
    new RegExp(['ant-table-cell-fix-right', 'anticon'].join('|')).test(
      target?.className
    )
  ) {
    /**
     * Ignore Double click when:
     * - Checkbox
     * - Action menu fixed on right table
     * - Icon, child of icon
     */
    return;
  }

  callback();
}

export default onClickRow;
